import { PartyId3nezlril92b5k as PartyId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PartyId.mjs';
import {
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
  NotBlankString2t6vf2scdbmna as NotBlankString,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  Result3t1vadv16kmzk as Result,
  _Result___get_value__impl__bjfvqg316j9v81zgqwq as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2lptaeb4c2198 as _Result___get_isFailure__impl__jpiriv,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { PlayerId3vdbn0bzxjwb4 as PlayerId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/player/PlayerId.mjs';
import { PinId3lhhfdu3qni8f as PinId } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/pin/Pin.mjs';
import { Companion_getInstance1bxbth0yni76u as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { ClientDispatcher1p2vginamq4dq as ClientDispatcher } from '../ClientDispatcher.mjs';
import { DispatcherPipeCannon3aitdk4bdtfxf as DispatcherPipeCannon } from '../../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionCannon.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { defaultClient32xevb6g4ofep as defaultClient } from '../../../../../../Coupling-sdk/com/zegreatrob/coupling/sdk/KtorSyntax.mjs';
import { LoggingActionPipenpslk1461eyq as LoggingActionPipe } from '../../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/LoggingActionPipe.mjs';
import { couplingSdk1kvwqabhypuft as couplingSdk } from '../../../../../../Coupling-sdk/com/zegreatrob/coupling/sdk/KtorSdk.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_partyId(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.pathParams['partyId'];
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = PartyId(tmp0_safe_receiver);
  }
  return tmp;
}
function get_playerId(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.pathParams['playerId'];
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : new (Result())(toNotBlankString(tmp0_safe_receiver));
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp1_safe_receiver.zs_1;
    var tmp_0 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
    tmp = tmp_0 == null ? null : tmp_0.v28_1;
  }
  var tmp2_safe_receiver = tmp;
  var tmp_1;
  var tmp_2 = tmp2_safe_receiver;
  if ((tmp_2 == null ? null : new (NotBlankString())(tmp_2)) == null) {
    tmp_1 = null;
  } else {
    var tmp_3 = tmp2_safe_receiver;
    // Inline function 'kotlin.let' call
    var p0 = (tmp_3 == null ? null : new (NotBlankString())(tmp_3)).v28_1;
    tmp_1 = new (PlayerId())(p0);
  }
  return tmp_1;
}
function get_pinId(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.pathParams['pinId'];
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : new (Result())(toNotBlankString(tmp0_safe_receiver));
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp1_safe_receiver.zs_1;
    var tmp_0 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
    tmp = tmp_0 == null ? null : tmp_0.v28_1;
  }
  var tmp2_safe_receiver = tmp;
  var tmp_1;
  var tmp_2 = tmp2_safe_receiver;
  if ((tmp_2 == null ? null : new (NotBlankString())(tmp_2)) == null) {
    tmp_1 = null;
  } else {
    var tmp_3 = tmp2_safe_receiver;
    // Inline function 'kotlin.let' call
    var p0 = (tmp_3 == null ? null : new (NotBlankString())(tmp_3)).v28_1;
    tmp_1 = new (PinId())(p0);
  }
  return tmp_1;
}
function tracingCannon() {
  // Inline function 'kotlin.let' call
  var it = this.m7h(Companion_getInstance().ht());
  return new (DispatcherPipeCannon())(new (ClientDispatcher())(it.s2e_1), it.t2e_1);
}
var CommanderClass;
function Commander() {
  if (CommanderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Commander');
    CommanderClass = $;
  }
  return CommanderClass;
}
var MasterCommanderClass;
function MasterCommander() {
  if (MasterCommanderClass === VOID) {
    class $ {
      constructor(getIdentityToken) {
        this.n7h_1 = getIdentityToken;
      }
      m7h(traceId) {
        return couplingSdk(this.n7h_1, defaultClient(apiUrl(), traceId), new (LoggingActionPipe())(traceId));
      }
    }
    protoOf($).o7g = tracingCannon;
    initMetadataForClass($, 'MasterCommander', VOID, VOID, [Commander()]);
    MasterCommanderClass = $;
  }
  return MasterCommanderClass;
}
function apiUrl() {
  var tmp = window.location.hostname;
  // Inline function 'org.w3c.dom.get' call
  // Inline function 'kotlin.js.asDynamic' call
  return 'https://' + tmp + window['basename'];
}
//region block: exports
export {
  MasterCommander as MasterCommander1cpk84os63u71,
  get_partyId as get_partyIdtdmkxlhw1ltr,
  get_pinId as get_pinId1iczo85zhgdfq,
  get_playerId as get_playerId4bqakxenosu,
};
//endregion

//# sourceMappingURL=PageProps.mjs.map
